module.exports = "/_next/static/images/deco-wave-footer-10e22ff7425634179e2bd73120edd5fc.png";